import React from 'react';

import {StyledModalImage} from '../components/boundImageModal';
import Modal from '../components/modal';

interface MessagePayload {
  type: string;
}

interface ImageModalMessagePayload extends MessagePayload {
  src: string;
  maxWidth?: string;
}

interface State {
  isActive: boolean;
  src?: string;
  maxWidth?: string;
}

class LegacyImageModal extends React.Component<{}, State> {
  public state: Readonly<State> = {
    isActive: false
  };

  private readonly allowedOrigins: ReadonlyArray<string> = [
    window.location.origin,
    'https://api.bitmovin.com',
    'http://api.bitmovin.com'
  ];

  constructor(props) {
    super(props);
    this.onPostMessage = this.onPostMessage.bind(this);
  }

  public componentDidMount(): void {
    window.addEventListener('message', this.onPostMessage, false);
  }

  public componentWillUnmount(): void {
    window.removeEventListener('message', this.onPostMessage, false);
  }

  private isAllowedOrigin(origin: string): boolean {
    if (this.allowedOrigins.includes(origin)) {
      return true;
    }

    if (/^http:\/\/(localhost|127\.0\.0\.1)(:[0-9]+)?\/?$/.test(origin)) {
      return true;
    }

    return false;
  }

  private onPostMessage(message: MessageEvent): void {
    if (!this.isAllowedOrigin(message.origin)) {
      throw new Error(`Handling post message from origin ${message.origin} not allowed on ${window.location.origin}`);
    }

    let data: object;

    try {
      data = JSON.parse(message.data);
    } catch (e) {
      return;
    }

    const payload = data as MessagePayload;

    if (payload.type !== 'modal:image') {
      return;
    }

    this.setActive(payload as ImageModalMessagePayload);
  }

  private setActive = (payload: ImageModalMessagePayload) => {
    if (this.state.isActive === true) {
      return;
    }

    this.setState({
      isActive: true,
      src: payload.src,
      maxWidth: payload.maxWidth
    });
  };

  private setInactive = () => {
    if (this.state.isActive === false) {
      return;
    }

    this.setState({
      isActive: false,
      src: undefined,
      maxWidth: undefined
    });
  };

  public render(): React.ReactNode {
    return (
      <Modal show={this.state.isActive} onClose={this.setInactive} maxWidth={this.state.maxWidth}>
        <StyledModalImage src={this.state.src} />
      </Modal>
    );
  }
}

export default LegacyImageModal;
